(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tll-keepsake-home')) {
  class TllKeepsakeHome extends HTMLElement {
    static instances = new Set();
    static pending = false;
    static cartPending = false;
    static schedule = () => {
      if (this.pending) return;
      this.pending = true;
      requestAnimationFrame(() => { this.pending = false; this.updateBars(); });
    };
    static updateBars() {
      const mobile = window.matchMedia('(max-width: 759px)').matches;
      const opened = [...this.instances].some(root => root.querySelector('dialog[open]'));
      let owner = null;
      if (mobile && !opened) {
        for (const root of this.instances) {
          const bounds = root.getBoundingClientRect();
          const heroAction = root.querySelector('.tllc-hero-action .tllc-button')?.getBoundingClientRect();
          const formAction = root.querySelector('[data-tllc-buy]')?.getBoundingClientRect();
          const actionVisible = [heroAction, formAction].some(rect => rect && rect.top >= 0 && rect.bottom <= window.innerHeight - 90);
          if (bounds.top < window.innerHeight / 2 && bounds.bottom > 112 && !actionVisible && root.querySelector('[data-tllc-bar]')) owner = root;
        }
      }
      for (const root of this.instances) {
        const bar = root.querySelector('[data-tllc-bar]');
        if (bar) {
          bar.hidden = root !== owner;
          const editionRegion = root.querySelector('.tllc-editions');
          const reached = editionRegion && editionRegion.getBoundingClientRect().top < window.innerHeight * .5;
          const purchase = bar.querySelector('[data-tllc-sticky-buy]');
          const choose = bar.querySelector('[data-tllc-choose]');
          if (purchase) purchase.hidden = !reached;
          if (choose) choose.hidden = reached;
        }
      }
    }
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-tllc-open]').forEach(button => { button.hidden = false; });
      this.querySelectorAll('.tllc-reader-fallback').forEach(details => { details.hidden = true; });
      this.dataset.tllcEnhanced = '';
      const keeper = this.querySelector('.tllc-keeper-details');
      if (keeper) keeper.open = Boolean(keeper.querySelector('.tllc-keeper-success, .tllc-keeper-error'));
      this.querySelector('[data-tllc-video]')?.addEventListener('error', () => {
        const message = this.querySelector('[data-tllc-film-error]');
        if (message) message.hidden = false;
      }, options);
      const film = this.querySelector('[data-tllc-video]');
      const ending = this.querySelector('[data-tllc-film-ending]');
      if (film && ending) {
        film.addEventListener('ended', () => { ending.hidden = false; }, options);
        film.addEventListener('play', () => { ending.hidden = true; }, options);
      }
      this.addEventListener('play', event => {
        if (!(event.target instanceof HTMLMediaElement)) return;
        document.querySelectorAll('tll-keepsake-home audio, tll-keepsake-home video').forEach(media => { if (media !== event.target) media.pause(); });
      }, { ...options, capture: true });
      this.setupPurchase(options);
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-tllc-open]');
        const close = event.target.closest('[data-tllc-close]');
        const sample = event.target.closest('[data-tllc-select]');
        if (trigger && this.contains(trigger)) this.openDialog(trigger);
        else if (event.target.closest('[data-tllc-film-choose]')) { this.returnFocus = null; event.target.closest('dialog').close(); this.querySelector('input[name="id"]:checked')?.focus({preventScroll:true}); }
        else if (close) close.closest('dialog').close();
        else if (sample) this.selectSample(sample.dataset.tllcSelect);
        else if (event.target instanceof HTMLDialogElement) {
          const box = event.target.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
        }
      }, options);
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => {
        dialog.querySelectorAll('video').forEach(video => video.pause());
        queueMicrotask(() => {
          if (!document.querySelector('tll-keepsake-home dialog[open]')) {
            document.documentElement.classList.remove('tllc-dialog-open');
            if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
          }
          TllKeepsakeHome.schedule();
        });
      }, options));
      TllKeepsakeHome.instances.add(this);
      if (TllKeepsakeHome.instances.size === 1) {
        window.addEventListener('scroll', TllKeepsakeHome.schedule, { passive: true });
        window.addEventListener('resize', TllKeepsakeHome.schedule, { passive: true });
      }
      TllKeepsakeHome.schedule();
    }
    setupPurchase(options) {
      const form = this.querySelector('.tllc-purchase');
      const config = this.querySelector('[data-tllc-purchase-config]');
      const word = this.querySelector('[data-tllc-word]');
      const meaning = this.querySelector('[data-tllc-meaning]');
      const wordOutput = this.querySelector('[data-tllc-word-output]');
      const meaningOutput = this.querySelector('[data-tllc-meaning-output]');
      const initialWord = wordOutput.textContent;
      const initialMeaning = meaningOutput.textContent;
      word.addEventListener('input', () => { wordOutput.textContent = word.value.trim() || initialWord; }, options);
      meaning.addEventListener('input', () => { meaningOutput.textContent = meaning.value.trim() || initialMeaning; }, options);
      if (!form || !config) return;
      const button = form.querySelector('[data-tllc-buy]');
      const buttonLabel = button.querySelector('[data-tllc-buy-label]');
      const stickyButton = this.querySelector('[data-tllc-sticky-buy]');
      const summary = form.querySelector('[data-tllc-summary]');
      const message = form.querySelector('.tllc-cart-message');
      const status = message.querySelector('[data-tllc-status]');
      const update = () => {
        const choice = form.querySelector('input[name="id"]:checked');
        button.disabled = !choice || choice.disabled || TllKeepsakeHome.cartPending;
        if (stickyButton) stickyButton.disabled = button.disabled;
        if (choice) {
          buttonLabel.textContent = choice.dataset.label;
          summary.textContent = choice.dataset.summary;
          form.querySelector('[data-tllc-summary-details]').textContent = choice.dataset.details;
          const palette = form.querySelector('input[name="properties[Preferred storybook palette]"]:checked');
          const modeChoice = form.querySelector('input[name="properties[_tll_purchase_mode]"]:checked');
          form.querySelector('[data-tllc-summary-options]').textContent = [palette?.value, modeChoice?.nextElementSibling?.textContent].filter(Boolean).join(' · ');
          if (stickyButton) stickyButton.querySelector('[data-tllc-buy-label]').textContent = choice.dataset.label;
        }
        const mode = form.querySelector('input[name="properties[_tll_purchase_mode]"]:checked')?.value;
        this.querySelectorAll('[data-tllc-mode-note]').forEach(note => { note.hidden = note.dataset.tllcModeNote !== mode; });
      };
      form.addEventListener('change', update, options);
      update();
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (TllKeepsakeHome.cartPending || !form.reportValidity()) return;
        const choice = form.querySelector('input[name="id"]:checked');
        if (!choice || choice.disabled) return;
        const payload = new FormData(form);
        const inputs = [...form.querySelectorAll('input, select')].map(input => ({input, disabled: input.disabled}));
        inputs.forEach(({input}) => { input.disabled = true; });
        TllKeepsakeHome.cartPending = true;
        button.disabled = true;
        buttonLabel.textContent = config.dataset.busy;
        if (stickyButton) { stickyButton.disabled = true; stickyButton.querySelector('[data-tllc-buy-label]').textContent = config.dataset.busy; }
        message.hidden = true;
        try {
          const check = await fetch(config.dataset.cartUrl + '.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
          if (!check.ok) throw new Error('cart-read');
          const cart = await check.json();
          if (!Array.isArray(cart.items)) throw new Error('cart-shape');
          if (cart.items.length) {
            status.textContent = cart.items.length === 1 && String(cart.items[0].variant_id) === choice.value ? config.dataset.same : config.dataset.existing;
            message.hidden = false;
            return;
          }
          const response = await fetch(config.dataset.addUrl + '.js', {method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:payload});
          if (!response.ok) throw new Error('cart-add');
          window.location.assign(config.dataset.cartUrl);
        } catch (error) {
          status.textContent = config.dataset.error;
          message.hidden = false;
        } finally {
          inputs.forEach(({input, disabled}) => { input.disabled = disabled; });
          TllKeepsakeHome.cartPending = false;
          update();
        }
      }, options);
    }
    openDialog(trigger) {
      const dialog = this.querySelector(`[data-tllc-dialog="${trigger.dataset.tllcOpen}"]`);
      if (!dialog || dialog.open) return;
      document.querySelectorAll('tll-keepsake-home dialog[open]').forEach(open => open.close());
      this.returnFocus = trigger;
      if (trigger.dataset.tllcSample) this.selectSample(trigger.dataset.tllcSample);
      const video = dialog.querySelector('video[data-tllc-video]');
      if (video?.error) video.removeAttribute('src');
      const filmError = dialog.querySelector('[data-tllc-film-error]');
      if (filmError) filmError.hidden = true;
      if (video && !video.hasAttribute('src')) {
        video.querySelectorAll('[data-tllc-track]').forEach(track => { track.src = track.dataset.tllcTrack; });
        video.src = video.dataset.tllcVideo;
      }
      dialog.showModal();
      if (video) {
        if (video.ended) video.currentTime = 0;
        const playback = video.play();
        if (playback?.catch) playback.catch(() => {});
      }
      document.documentElement.classList.add('tllc-dialog-open');
      dialog.querySelector('[data-tllc-close]').focus({ preventScroll: true });
      TllKeepsakeHome.schedule();
    }
    selectSample(name) {
      if (!this.querySelector(`[data-tllc-panel="${name}"]`)) return;
      this.querySelectorAll('[data-tllc-panel]').forEach(panel => { panel.hidden = panel.dataset.tllcPanel !== name; });
      this.querySelectorAll('[data-tllc-select]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.tllcSelect === name)));
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      this.querySelectorAll('video, audio').forEach(media => media.pause());
      this.controller?.abort();
      this.controller = null;
      TllKeepsakeHome.instances.delete(this);
      if (!document.querySelector('tll-keepsake-home dialog[open]')) document.documentElement.classList.remove('tllc-dialog-open');
      if (!TllKeepsakeHome.instances.size) {
        window.removeEventListener('scroll', TllKeepsakeHome.schedule);
        window.removeEventListener('resize', TllKeepsakeHome.schedule);
      }
      TllKeepsakeHome.schedule();
    }
  }
  customElements.define('tll-keepsake-home', TllKeepsakeHome);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product-before-behavior-20260830"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product-before-gifting-20260830"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product-before-recipient-style-20260830"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const purchaseModes = section.querySelectorAll('[data-purchase-mode]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    const syncPurchaseMode = () => {
      const selected = section.querySelector('[data-purchase-mode]:checked');
      purchaseModes.forEach((input) => {
        const card = input.closest('[data-purchase-mode-card]');
        if (card) card.classList.toggle('is-selected', input.checked);
      });
      const activeLabel = selected && selected.value === 'gift'
        ? addButton.dataset.giftLabel
        : addButton.dataset.availableLabel;
      if (addLabel && addButton && !previewMode && !addButton.disabled) {
        addLabel.textContent = activeLabel;
      }
      if (stickyLabel && addButton && !previewMode && !addButton.disabled) {
        stickyLabel.textContent = activeLabel;
      }
    };

    purchaseModes.forEach((input) => input.addEventListener('change', syncPurchaseMode));
    syncPurchaseMode();

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        syncPurchaseMode();
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const purchaseModes = section.querySelectorAll('[data-purchase-mode]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    const syncPurchaseMode = () => {
      const selected = section.querySelector('[data-purchase-mode]:checked');
      purchaseModes.forEach((input) => {
        const card = input.closest('[data-purchase-mode-card]');
        if (card) card.classList.toggle('is-selected', input.checked);
      });
      const activeLabel = selected && selected.value === 'gift'
        ? addButton.dataset.giftLabel
        : addButton.dataset.availableLabel;
      if (addLabel && addButton && !previewMode && !addButton.disabled) {
        addLabel.textContent = activeLabel;
      }
      if (stickyLabel && addButton && !previewMode && !addButton.disabled) {
        stickyLabel.textContent = activeLabel;
      }
    };

    purchaseModes.forEach((input) => input.addEventListener('change', syncPurchaseMode));
    syncPurchaseMode();

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        syncPurchaseMode();
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();
})();
